module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Mellingen_AG-57b629c7329d44e0d90ba28d84733d4d.svg";